/* Kopstorm Black Friday layer: live viewers and the delivery date on the product page.
   Both are rendered server side first, this only keeps them correct (cached pages, midnight, cutoff time).
   product-rerender swaps the product info on every variant change, so new nodes are picked up by an observer. */
(function () {
  'use strict';

  var DAY = 86400000;

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, String(value));
    } catch (e) {
      return null;
    }
    return null;
  }

  function initViewers(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 2;
    var max = parseInt(el.getAttribute('data-max'), 10) || min;
    var countEl = el.querySelector('[data-kop-bf-viewers-count]');
    if (!countEl) return;
    var key = 'kopBfViewers:' + el.getAttribute('data-key');
    var saved = parseInt(store(key), 10);
    var value = saved >= min && saved <= max ? saved : rand(min, max);
    countEl.textContent = value;
    store(key, value);

    function tick() {
      if (!document.body.contains(el)) return;
      var step = rand(-2, 2);
      value = Math.min(max, Math.max(min, value + step));
      countEl.textContent = value;
      store(key, value);
      window.setTimeout(tick, rand(7000, 13000));
    }
    window.setTimeout(tick, rand(7000, 13000));
  }

  /* Same rules as the Liquid in kopstorm-bf-pdp: after the cutoff hour the order ships the next day,
     weekends are skipped, then the extra business days are added. Computed in the shop timezone. */
  function shipLabel(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var days = parseInt(el.getAttribute('data-days'), 10) || 0;
    var tz = el.getAttribute('data-tz') || '+0000';
    var sign = tz.charAt(0) === '-' ? -1 : 1;
    var offset = sign * (parseInt(tz.substr(1, 2), 10) * 60 + parseInt(tz.substr(3, 2), 10));
    var dayNames = (el.getAttribute('data-day-names') || '').split(',');
    var monthNames = (el.getAttribute('data-month-names') || '').split(',');
    if (dayNames.length !== 7 || monthNames.length !== 12) return null;

    var d = new Date(Date.now() + offset * 60000);
    if (d.getUTCHours() >= cutoff) d = new Date(d.getTime() + DAY);
    while (d.getUTCDay() === 0 || d.getUTCDay() === 6) d = new Date(d.getTime() + DAY);
    while (days > 0) {
      d = new Date(d.getTime() + DAY);
      if (d.getUTCDay() !== 0 && d.getUTCDay() !== 6) days -= 1;
    }
    var weekdayIndex = (d.getUTCDay() + 6) % 7;
    return dayNames[weekdayIndex] + ' ' + d.getUTCDate() + ' ' + monthNames[d.getUTCMonth()];
  }

  function initShip(el) {
    var target = el.querySelector('[data-kop-bf-ship-date]');
    if (!target) return;
    var label = shipLabel(el);
    if (label && target.textContent !== label) target.textContent = label;
  }

  function scan() {
    document.querySelectorAll('[data-kop-bf-viewers]:not([data-kop-ready])').forEach(function (el) {
      el.setAttribute('data-kop-ready', '');
      initViewers(el);
    });
    document.querySelectorAll('[data-kop-bf-ship]:not([data-kop-ready])').forEach(function (el) {
      el.setAttribute('data-kop-ready', '');
      initShip(el);
    });
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  function start() {
    scan();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queueScan();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
